var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/aaaprovisioning/viewmodels/index',["require", "exports", "common/viewmodelbase", "services/settings"], function (require, exports, Common, Settings) {
    "use strict";
    var AAAProvisioningViewModel = (function (_super) {
        __extends(AAAProvisioningViewModel, _super);
        function AAAProvisioningViewModel() {
            _super.call(this);
        }
        AAAProvisioningViewModel.prototype.onActivated = function (context) {
            var aaaOrganizationalUnitId = Settings.Settings.environment.userManager.aaaConfiguration.organizationalUnitId;
            this.aaaProvisioningUrl = Settings.Settings.environment.userManager.serverUrl + '/selfservice/extern/security?s=pm&brandingId=' + aaaOrganizationalUnitId + '&returnUrl=' + window.location.origin + "&plainUrl=true";
            window.location.assign(this.aaaProvisioningUrl);
        };
        return AAAProvisioningViewModel;
    }(Common.ViewModelBase));
    var instance = new AAAProvisioningViewModel();
    return instance;
});

